import { WSQueryConfig } from "@ws-react-query";

import { useWSQuery } from "../../helpers";
import { QUERY_SHARED_FILE } from "../keys";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { getSharedFile } from "../../../services/sharedFile/getSharedFile";

export const useSharedFileQuery = (
  sharedFileId: string,
  queryConfig?: WSQueryConfig<ISharedFileRequestResponse, unknown>
) =>
  useWSQuery(
    [QUERY_SHARED_FILE, sharedFileId],
    () => getSharedFile(sharedFileId),
    {
      retry: false,
      refetchOnMount: false,
      ...queryConfig
    }
  );
